export enum EvaluationsPath {
  LISTE = '',
  CREATION_PREFORMATION = 'creer-preformation',
  CREATION_ACHAUD = 'creation-a-chaud',
  CREATION_AFROID= 'creation-a-froid',
  ROOT = 'evaluation',
  ID_MODELE = 'idmodele',
  EDITION = 'edition',
}
